import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Mixpanel } from "../../config/Mixpanel";
import Constants from "../../common/constants";
import { ClipLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import "./index.css";

const cradFeatures = [
  "Industry-Verified Certification",
  "Lifetime Access to 3100+ More Courses",
  "Live Doubt Solving",
  "Industry-Relevant Projects",
];

const PricingCard = ({ razorpayHandler, onboardingData, handleSkip }) => {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  return (
    <div className="pricing-card-linear-gradient-background rounded-2xl border-2 border-[#1CA571] p-4 text-center">
      <p className="mb-3 text-sm font-semibold md:hidden">
        Get A Personalised Course & Grow 3x Faster
      </p>
      <p className="mb-3 mt-2 hidden text-xl font-semibold md:block">
        Would You Like To Be An Expert With Personalised Course?
      </p>
      <div className="mt-5 hidden md:grid md:grid-cols-2 md:gap-x-8">
        {cradFeatures?.map((item, index) => (
          <div
            key={index}
            className="mt-2 flex items-center justify-center rounded-lg bg-[#1A3A5A] py-2 px-1"
          >
            <FontAwesomeIcon icon={faCircleCheck} color="#4AAD60" />
            <p className="ml-2  text-sm font-semibold">{item}</p>
          </div>
        ))}
      </div>
      <div className="mt-4 flex w-full flex-col gap-y-2 md:flex-row md:items-center md:justify-between md:gap-x-2">
        <div
          className="flex cursor-pointer items-center justify-center rounded-lg bg-[#1CA571] p-2 md:w-1/2"
          onClick={() => {
            Mixpanel.track(
              Constants.Mixpanel
                .PERSONALISE_PAGE_ANALYSIS_TOP_PERSONALISE_PAYMENT,
            );
            setLoading(true);
            razorpayHandler(() => setLoading(false));
          }}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              <ClipLoader color="black" size={20} />
            </div>
          ) : (
            <>
              <div>
                <p className="font-semibold">Unlock Personalised Course</p>
                <p className="text-xs font-medium">
                  Early Bird Discount: ₹199{" "}
                  <span className="text-[#FF2633]">₹</span>
                  <span className="text-[#FF2633] line-through">1199</span>
                </p>
              </div>
              <div className="ml-3">
                <img
                  src="https://img.learntube.ai/public-assets/Onboarding_Revamp/Arrow.png?updatedAt=1694517910311"
                  width={34}
                  height={34}
                  alt="right arrow"
                />
              </div>
            </>
          )}
        </div>
        <p className="text-center font-semibold ">or</p>
        <div
          className="cursor-pointer rounded-lg border-2 border-[#1983D0] bg-[#0E2C4B] p-2 md:w-1/2"
          onClick={() => {
            Mixpanel.track(
              Constants.Mixpanel.PERSONALISE_PAGE_ANALYSIS_TOP_NORMAL,
            );
            handleSkip();
          }}
        >
          <p className="font-semibold text-[#1983D0]">
            Continue To Standard Course (Free)
          </p>
          <p className="text-xs font-medium">
            {" "}
            Verified certificate not included
          </p>
        </div>
      </div>
    </div>
  );
};

export default PricingCard;
